import { SampleFields } from '@app/modules/service-data/components/sample/sample-dialog/field-sets/sample-fields.enum';

export const cancerscreenSampleFieldSet = [
  SampleFields.SampleType,
  SampleFields.EditFieldsAvailable,
];
